module.exports = __webpack_public_path__ + "img/donante-cruz-roja.1423061a.jpeg";